import _ from "lodash";
import { useCallback, useReducer } from "react";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import { ITagPollingSchedule } from "../../services/properties-data-service/Models";


export type ModifyPollingScheduleStateType = {
    filterText: string;
    viewOptionState: ViewOptionStateEnum
    selectedPollingSchedules: ITagPollingSchedule[]
};

enum ModifyPollingScheduleActionType {
    FilterChanged = "FILTER_TEXT_CHANGED",
    SelectedPollingSchedulesChanged = "SELECTED_POLLING_SCHEDULES_CHANGED",
    ViewSelectedChanged = "VIEW_SELECTED_CHANGED",
    ResetChanged = "RESET_CHANGED",
}

type ModifyPollingScheduleAction = {
     type: ModifyPollingScheduleActionType.FilterChanged;
     payload: string;
} | {
    type: ModifyPollingScheduleActionType.SelectedPollingSchedulesChanged;
    payload: ITagPollingSchedule[];
} | {
    type: ModifyPollingScheduleActionType.ViewSelectedChanged;
    payload: boolean;
} | {
    type: ModifyPollingScheduleActionType.ResetChanged;
    payload: void;
};

const initialState: ModifyPollingScheduleStateType = {
    filterText: '',
    selectedPollingSchedules: [{
            id: -1,
            description: 'All Schedules',
            selected: true,
    }],
    viewOptionState: ViewOptionStateEnum.Default,
};

const optionsChanged = (newState: ModifyPollingScheduleStateType, 
    defaultState: ModifyPollingScheduleStateType) => 
    newState.filterText !== defaultState.filterText || 
    newState.selectedPollingSchedules.some(o => o.id !== -1 && o.selected);

function modifyPollingScheduleDialogReducer(state: ModifyPollingScheduleStateType, 
        action: ModifyPollingScheduleAction): ModifyPollingScheduleStateType {

    let copy = _.cloneDeep(state);    

    switch (action.type) {

        case ModifyPollingScheduleActionType.FilterChanged:
            copy.filterText = action.payload;
            break;
    
        case ModifyPollingScheduleActionType.ResetChanged:
            const items = _.cloneDeep(state.selectedPollingSchedules);
            items.forEach(o => o.selected = o.id === -1);
            copy = _.cloneDeep(initialState);
            copy.selectedPollingSchedules = items;
            break;

        case ModifyPollingScheduleActionType.SelectedPollingSchedulesChanged:
            copy.selectedPollingSchedules = action.payload;
            break;

        default:
            return state;
    }

    copy.viewOptionState = optionsChanged(copy, initialState) ? 
                            ViewOptionStateEnum.Changed : 
                            ViewOptionStateEnum.Default;

    return copy;
}

export type UseModifyPollingScheduleStateType = {
    state: ModifyPollingScheduleStateType;
    setFilter: (value: string) => void;
    setSelectedPollingSchedules: (value: ITagPollingSchedule[]) => void;
    resetState: () => void;
};

export function useModifyPollingScheduleState(): UseModifyPollingScheduleStateType {

    const [state, dispatch] = useReducer(modifyPollingScheduleDialogReducer, initialState);


    const setFilter = useCallback((value: string) => dispatch({
        type: ModifyPollingScheduleActionType.FilterChanged,
        payload: value
    }), []);

    const setSelectedPollingSchedules = useCallback((value: ITagPollingSchedule[]) => dispatch({
        type: ModifyPollingScheduleActionType.SelectedPollingSchedulesChanged,
        payload: value
    }), []);


    const resetState = useCallback(() => dispatch({
        type: ModifyPollingScheduleActionType.ResetChanged,
        payload: undefined
    }), [])

    return {
        state,
        setFilter,
        setSelectedPollingSchedules,
        resetState
    };
}
